
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  border-radius: 0.375rem;
  background-color: var(--outline-white);
  box-shadow:0px 4px 14px 0px rgb(0, 0, 0, 0.1) !important
}

.card-image img {
  max-height: 11.125rem;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px
}

.card-content-wrapper {
  display: flex;
  flex-direction: row;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 1.5rem
}

@media (min-width: 768px){
  .card-content-wrapper {
    padding-top: 0.5rem
  }
  .card-content-wrapper {
    padding-bottom: 1.5rem
  }
}

.card-number {
  margin-top: 0px;
  margin-bottom: 0px;
  margin-right: 0.5rem;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  font-weight: var(--fw-semibold);
  color: var(--orange-lighten-1)
}

.card-title {
  margin-top: 0.25rem
}

.outline-shadow {
  --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1);
  --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.card-number {
  margin-top: 0.75rem;
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl)
}

@media (min-width: 768px){
  .card-number {
    margin-top: 1rem
  }
  .card-number {
    font-size: var(--fs-3xl);
    line-height: var(--lh-3xl)
  }
}

@media (min-width: 768px) {

  .image-position--top .card-image, .image-position--top .card-content-wrapper {
    width: 100%
  }
}

idb-heading {
  color: var(--blue-responsible-darken-1)
}

a:focus .card-title, a:hover .card-title {
  color: var(--blue-responsible-darken-1);
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline
}

.card-content idb-styled-text {
  color: var(--gray-professional-lighten-1);
  display:-webkit-box;
  -webkit-line-clamp:4;
  -webkit-box-orient:vertical;
  overflow:hidden;
  word-break:break-word
}
`;